import {useEffect, useState} from 'react'
import Spinner from 'layout/common/Spinner'

import ReportCard from './components/ReportCard'
import {getReportsConfigsApi} from 'utils/api/reportService'
import {ReportConfig} from 'models/Reports'
import {useTranslation} from 'react-i18next'
import {PageTitle} from 'layout/master-layout'

export default function Reports() {
 const [reports, setReports] = useState<ReportConfig[]>([])
 const [loading, setLoading] = useState(false)
 const {t} = useTranslation()
 const fetchReports = async () => {
  setLoading(true)

  const res = await getReportsConfigsApi()

  if (res?.data) {
   setReports(res.data)
  }

  setLoading(false)
 }

 useEffect(() => {
  void fetchReports()
 }, [])

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white w-full min-h-full'>
    <PageTitle
     breadcrumbContainerClass='flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0]'
     breadcrumbs={[
      {
       title: t('breadCrumbs.home'),
       path: '/home-page',
       isActive: false,
      },
      {
       title: t('breadCrumbs.quickLinks'),
       path: '/quick-links',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     Quick Links
    </PageTitle>

    <div className='text-black  text-[18px] font-medium mb-[28px]'>
     {t('reports.AllReports')}
    </div>

    {loading ? (
     <Spinner />
    ) : (
     <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
      {reports.map((report) => (
       <ReportCard
        key={report.report_key}
        reportKey={report.report_key}
        title={report.report_display_name || ''}
        description={report.description || ''}
        image={report.image_url}
        details={report.details}
       />
      ))}
     </div>
    )}
   </div>
  </div>
 )
}
